export enum FeaturesRequest {
  AUTH = 'AUTH',
  SYSTEM = 'SYSTEM',
  CLARITY = 'CLARITY',
  ANALYTICS = 'ANALYTICS',
  WORKFLOW = 'WORKFLOW',
  CREATE_PODCAST = 'CREATE PODCAST',
  UPDATE_PODCAST = 'UPDATE PODCAST',
  DELETE_PODCAST = 'DELETE PODCAST',
  CREATE_EPISODE = 'CREATE EPISODE',
  UPDATE_EPISODE = 'UPDATE EPISODE',
  DELETE_EPISODE = 'DELETE EPISODE',
  REVOKE_ACCESS_MEMBER = 'REVOKE ACCESS MEMBER',
  REJECT_ACCESS_REQUEST = 'REJECT ACCESS REQUEST',
  APPROVE_ACCESS_REQUEST = 'APPROVE ACCESS REQUEST',
  UPDATE_MEMBER_ROLE = 'UPDATE MEMBER ROLE',
  INVITE_MEMBERS = 'INVITE MEMBERS',
  CONFIGURE_PODCAST = 'CONFIGURE PODCAST',
  CREATE_MUSIC = 'CREATE MUSIC',
  CREATE_SCRIPT = 'CREATE SCRIPT',
  UPDATE_SCRIPT = 'UPDATE SCRIPT',
  DELETE_SCRIPT = 'DELETE SCRIPT',
  CREATE_AUDIO = 'CREATE AUDIO',
  PUBLISH_EPISODE = 'PUBLISH EPISODE',
  CHANGE_VOICE_HOST = 'CHANGE VOICE HOST',
  CREATE_PROJECT = 'CREATE PROJECT',
  EDIT_PROJECT = 'EDIT PROJECT',
  DELETE_PROJECT = 'DELETE PROJECT',
}
